var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "video")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message-Templates",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sf_WA_template_new_media",
    transform: "translate(-489.000000, -875.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tab_card",
    transform: "translate(262.000000, 635.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(16.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(16.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Visual-Picker-/-Coverable-Content-Copy-5",
    transform: "translate(149.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/slideshow_24px",
    transform: "translate(39.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333333,18.6666667 L23.3333333,37.3333333 L35,28 L23.3333333,18.6666667 Z M44.3333333,7 L11.6666667,7 C9.1,7 7,9.1 7,11.6666667 L7,44.3333333 C7,46.9 9.1,49 11.6666667,49 L44.3333333,49 C46.9,49 49,46.9 49,44.3333333 L49,11.6666667 C49,9.1 46.9,7 44.3333333,7 Z M44.3333333,44.3333333 L11.6666667,44.3333333 L11.6666667,11.6666667 L44.3333333,11.6666667 L44.3333333,44.3333333 Z",
    fill: "#FFFFFF"
  }))))))))));
};
export default SvgVideo;